import { andonApi } from "./andon";

export const { useToggleHandRaiseMutation, useLazyGetAndonStateQuery } =
  andonApi;
